import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import * as uuidV4 from "uuid/v4";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { Event } from "../../../Entity/Entities/Event/Event";
import Time from "../../../Time/Time";
import Formatter from "../../../Localization/Formatter";
import Store from "../../../Store/Store";
import { PageTransition } from "../../Partials/Spinner/PageTransition";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { NewChargeStep3 } from "./NewCoach/NewCoachContents/NewChargeStep3";
import { NewChargeStep4 } from "./NewCoach/NewCoachContents/NewChargeStep4";
import { NewChargeStep5 } from "./NewCoach/NewCoachContents/NewChargeStep5";
import { CounterpartyStep } from "./NewCoach/NewCoachContents/CounterpartyStep";

import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";

import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

export class CoachNewChargeBasedOnPayment extends Component {
  public defaultChargeTypeLabel: string = this.props.defaultChargeTypeLabel || null;
  public defaultChargeTypeId: string = this.props.defaultChargeTypeId || null;
  public chargeDetails;

  public defaultChargeState: any = {
    amountForCharge: "",
    // invoiceDateForCharge: new Date(),
    invoiceNumberForCharge: "",
    vatForCharge: "0,00",
    vatPercentageForCharge: 0,
    isInvoice: false,
    currencyIdForCharge: this.props.app?.settings?.user?.currency?.getCurrencyId(),
    showChargeOwnerChoice: true,
    chargeClassId: this.props.globalTypes?.ChargeType?.[this.defaultChargeTypeId]?.chargeClassId || 1,
    chargeOwnerChoice: "person",
    typeIdForCharge: this.defaultChargeTypeId || null,
    typeIdForChargeManuallyChanged: false,
    descriptionForCharge: this.defaultChargeTypeId ? `${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(this.defaultChargeTypeId)), this.defaultChargeTypeLabel)}, ${this.formatter.monthFullFormatDate(new Date())}` : '',
    selectedEntityForCharge: this.props.selectedObjectForNewCharge || null,
    selectedEntityForChargeManuallyChanged: false,
    selectedCounterpartyForCharge: null,
    periodForCharge: 3, // todo fix hardcoded value,
    firstDateForCharge: new Date(),
    dateOfPeriodForCharge: new Date(),
    descriptionForChargeIsManuallyChanged: false,
    isCreateChargeTypePopupOpen: false,
    renderChargeType: true,
    chargeTypeSelectField: null,
    isSettle: false,
    hasSettlementType: false,
    isLocked: false,
    isRemoved: false,
    isDisabled: false,
    charge: null,
    showInvoiceSwitch: true,
    hasSavingsType: false,
    openCoachCreateNewCounterparty: false,
    isCounterpartyFieldShown: true,
    name: "",
    showMore: false
  }
  
  public defaultState: any = {
    activeStep: 0,
    skipped: new Set(),
    openCoach: false,
    hasModifiedData: false,
    isSaving: false,
    showBackButton: true,
    isClosePreprocessDialogOpen: false,
    coachType: ChargeClassContainer.pickLabelFromId(this.defaultChargeState.chargeClassId),
    payerType: "owner",
    selectedOwner: null,
    selectedAgency: null,
    amazonFolderName: uuidV4(),
    attachments: [],
    newCharge: this.defaultChargeState,
    requestFailed: false,
    errors: null,
    chargeType: "payment",
    payment: null,
    showLoader: false,
    chargeCreatedSuccessfully: false,
    firstName: "",
    tenantChoice: "existingtenant",
    lastName: "",
    tenantType: "person",
    tenant: null,
    showNextButton: false,
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    companyTenant: null,
      
    //Occupant data
    occupantFirstName: "",
    occupantLastName: "",
    occupantDescription: this.trans("label-occupant"),
    counterpartyError: null,
    occupantsData: [],
    showAdditionalSection: false,
    counterpartySuccessfullyCreated: false
  }

  public state = {
    ...this.defaultState
  };

  constructor(public props) {
    super(props);

    this.chargeDetails = React.createRef();
  }

  public componentWillMount() {
    this.setState(this.defaultState);

    this.setState({
      openCoach: this.props.openCoach
    });

    if (this.props.payment) {
      const paymentClassId = this.props.payment?.paymentClass?.id;
      let typeIdForCharge: number;
      let chargeTypeLabel: string;

      if (paymentClassId == PaymentClassContainer.pickIdFromLabel("Payable")) {
        typeIdForCharge = TypeContainer.pickIdFromLabel("Other_payable");
        chargeTypeLabel = "Other_payable";
      } else {
        typeIdForCharge = TypeContainer.pickIdFromLabel("Other_receivable");
        chargeTypeLabel = "Other_receivable";
      }

      let descriptionForCharge;
      
      if(this.props.payment?.description) {
        descriptionForCharge = this.props.payment?.description;
      } else {
        descriptionForCharge = `${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(typeIdForCharge)), chargeTypeLabel)}, ${this.formatter.monthFullFormatDate(this.props.payment?.dateOfThePayment || new Date())}`;
      }

      // const vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.props?.app?.settings?.agency?.vatPercentage)).replace(",", ".")).toFixed(2));

      this.setState({
        chargeType: "payment",
        payment: this.props.payment,
        coachType: this.props.payment?.paymentClass?.label,
        tenant: this.props.payment?.counterparty,
        tenantChoice: "existingtenant",
        activeStep: 0,
        newCharge: {
          ...this.state.newCharge,
          chargeClassId: String(paymentClassId),
          amountForCharge: Formatter.simpleFormatNumber(this.props.payment?.amountRemaining),
          // vatForCharge: vatPercentageNumber ? Formatter.simpleFormatNumber(this.props.payment?.amountRemaining / (100 + vatPercentageNumber) * vatPercentageNumber) : "",
          // invoiceDateForCharge: this.props.payment?.dateOfThePayment,
          dueDateForCharge: this.props.payment?.dateOfThePayment,
          currencyIdForCharge: this.props.payment?.currency.getCurrencyId(),
          typeIdForCharge: typeIdForCharge,
          firstDateForCharge: this.props.payment?.dateOfThePayment || new Date(),
          dateOfPeriodForCharge: Time.firstDateSelectedMonth(this.props.payment?.dateOfThePayment) || new Date(),
          selectedEntityForCharge: null,
          selectedCounterpartyForCharge: this.props.payment?.counterparty,
          descriptionForCharge: descriptionForCharge,
          descriptionForChargeIsManuallyChanged: this.props.payment.description ? true : false
        }
      }, () => this.fetchChargeDetails(this.props.payment));
    }
	}

  public clearState = () => {
    this.setState({
      ...this.defaultState
    });
  }

  public onCloseCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);

    if (typeof this.props.onCloseCoach === "function") {
      this.props.onCloseCoach.call(this, this.state.chargeCreatedSuccessfully, this.state.charge);
    }
    this.setState({
      openCoach: false
    })
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    switch (this.state.coachType) {
      case "Receivable":
        return [
          this.trans("coach/newcharge-step1/title"),
          this.trans("label-counterparty"),
          this.trans("coach/newcharge-step4/title"),
          this.trans("summary"),
          this.trans("menuitem-finish"),
        ];
      case "Payable":
        return [
          this.trans("coach/newcharge-step1/title"),
          this.trans("label-counterparty"),
          this.trans("coach/newcharge-step4/title"),
          this.trans("summary"),
          this.trans("menuitem-finish"),
        ];
      case "registerIncomingInvoice":
        return [
          this.trans("credit_charge_for_payment"),
          this.trans("label-counterparty"),
          this.trans("summary"),
          this.trans("menuitem-finish"),
        ];
    }
  }

  public save = (): any => {

    this.setState({
      errors: null,
      counterpartyError: null,
      showLoader: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_CREATE_CLEAR
    });

    const charge: any = {
      amount: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2)),
      currency: this.state.newCharge?.currencyIdForCharge,
      type: this.state.newCharge?.typeIdForCharge,
      period: this.state.newCharge?.periodForCharge,
      firstDate: Time.formatOrNull(this.state.newCharge?.firstDateForCharge),
      dateOfPeriod: Time.formatOrNull(this.state.newCharge?.dateOfPeriodForCharge),
      dueDate: Time.formatOrNull(Time.firstDateSelectedMonth(this.state.newCharge?.dateOfPeriodForCharge)),
      description: this.state.newCharge?.descriptionForCharge,
      // invoiceDate: Time.formatOrNull(this.state.newCharge?.invoiceDateForCharge),
      invoiceNumber: this.state.newCharge?.invoiceNumberForCharge,
      isInvoice: this.state.newCharge?.isInvoice,
      amazonFolderName: this.state.amazonFolderName,
      paymentId: this.state.payment?.id,
      payment: this.state.payment,
      vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.vatForCharge)).replace(",", ".")).toFixed(2)),
    };

    if (this.state.newCharge?.selectedEntityForCharge instanceof Property) {
      charge.propertyId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Unit) {
      charge.unitId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Contract) {
      charge.contractId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Company) {
      charge.ownerId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Event) {
      charge.eventId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Person) {
      charge.contactId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
    }

    if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Company) {
      charge.companyId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
    }

    if (!this.state.newCharge.selectedEntityForCharge) {
      charge.ownerId = this.state.selectedOwner?.id || this.state.selectedAgency?.id;
    }

    if (this.state.attachments.length > 0) {
      charge.attachments = this.state.attachments;
    }

    if (!this.state.newCharge?.isCounterpartyFieldShown) {
      charge.name = this.state.newCharge?.name
    }

    if (!this.state.newCharge?.isInvoice) {
      charge.vat = null
    }

    return this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_START,
        payload: {
          charge: charge
        },
        onSuccess: (charge: ChargeInterface) => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.setState({
            charge: charge,
            requestFailed: false,
            showBackButton: false,
            activeStep: 4,
            showLoader: false,
            chargeCreatedSuccessfully: true
          }, () => {
            this.props.initializePage();
          });
        },
        onError: (err) => {
          return this.setState({
            hasModifiedData: true,
            requestFailed: true,
            errors: err,
            showLoader: false,
            chargeCreatedSuccessfully: false,
            // If we get error from counterparty step, show errors on counterparty step
            counterpartyError: err.fields.some(el => {
              return el === "contactId" || el === "companyId" || el === "name"
            }) ? err.errorId : null,
            activeStep: err.fields.some(el => {
              return el === "contactId" || el === "companyId" || el === "name"
            }) ? 1 : 4
          });
        }
      });
    });
  }

  //Funcionality for steps
  public startStep1 = () => {
    if (!this.state.newCharge.selectedCounterpartyForCharge) {
      this.setState({
        isDisabled: true
      })
    }
    return this.coachStartStep1();
  }

  public startStep2 = () => {
    return this.coachStartStep2();
  }

  public startStep3 = () => {
    return this.coachStartStep3();
  }

  public startStep4 = () => {
    return this.coachStartStep4();
  }

  //Methods for step logic
  public coachStartStep1 = () => {
    this.plusOneStep();
  }

  public coachStartStep2 = () => {
    this.plusOneStep();
  }

  public coachStartStep3 = () => {
    this.plusOneStep();
  }

  public coachStartStep4 = () => {
    this.save();
  }

  //Methods
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public changeCoachType = (event) => {
    const type = event.target.value;
    this.setState({
      coachType: type,
      newCharge: {
        ...this.state.newCharge,
        chargeClassId: ChargeClassContainer.pickIdFromLabel(type),
        isInvoice: type === "registerIncomingInvoice" ? true : false
      }
    }, () => {
      if (this.props.selectedObjectForNewCharge) {
        this.changeClassIdForCharge(this.state.newCharge.chargeClassId);
      }
    });
  }

  public changePayerType = (event) => {
    const type = event.target.value;
    const agency = this.getAgency();
    if (type === "agency") {
      this.setState({
        payerType: type,
        selectedOwner: null,
        selectedAgency: agency,
        ownerErrorMessage: null,
        newCharge: {
          ...this.defaultChargeState,
          isInvoice: this.state.coachType === "registerIncomingInvoice" ? true : false
        }
      });
    }
    if (type === "owner") {
      this.setState({
        payerType: type,
        selectedAgency: null,
        ownerErrorMessage: null,
        newCharge: {
          ...this.defaultChargeState,
          isInvoice: this.state.coachType === "registerIncomingInvoice" ? true : false
        }
      });
    }
    this.clearBackEndErrors();
  }

  public step6Details = () => {
    // TODO: We may not need fail page on step 6
    if (this.state.requestFailed) {
      return (
        <div>
          <Title
            title={this.trans("result")}
          />
          <div style={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>{this.image.getAvatar("info", { size: 62 })}</div>
          <div className="info-text-gray center">
            {this.trans("charge-creation-failed")}
          </div>
          <div className="info-text-gray center">
            {this.state.errors?.message}
          </div>
          <div className="info-text-gray center">
            {/* {this.state.errors?.fields.length && this.state.errors.fields.map(field => (
              <span>{field}, </span>
            ))} */}
          </div>
        </div>
      )
    } else {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("result")}
          />
          <div style={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>{this.image.getAvatar("success", { size: 62 })}</div>
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", {entity: this.trans("title-charge").toLowerCase()})}
          />
        </div>
      )
    }
  };

  public handleChargeStateChange = (data) => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        ...data
      }
    })
  }
  
  public clearEntityForCharge = (): void => {
    this.setState({
        newCharge: {
          ...this.state.newCharge,
          selectedEntityForCharge: null,
          hasModifiedData: true
      }
    });
  }

  public selectCounterpartyForCharge = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: entity,
        hasModifiedData: true
      },
      isDisabled: false
    });
  }

  public clearCounterpartyForCharge = (): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: null,
        hasModifiedData: true
      },
      isDisabled: true
    });
  }

  public changeDescriptionForCharge = (event): void => {
    const description: string = event.target.value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        descriptionForCharge: description,
        hasModifiedData: true,
        descriptionForChargeIsManuallyChanged: true
      }
    });
  }

  public changeClassIdForCharge = (value): void => {
    let chargeClassId: number = value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        chargeClassId: String(chargeClassId)
      }
    }, () => {
      // when we change class we should automatically change type
      const typeId: number = Number(this.state.newCharge?.chargeClassId) == ChargeClassContainer.pickIdFromLabel("Payable") ? 
                             TypeContainer.pickIdFromLabel("Other_payable") :
                             TypeContainer.pickIdFromLabel("Other_receivable");
      this.changeTypeIdForCharge(null, {props: {value: typeId}})                       
    });
  }

  public handleChangeIsInvoice = () => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        isInvoice: !this.state.newCharge.isInvoice
      }
    })
  }

  public handleShowMore = () => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        showMore: !this.state.newCharge.showMore
      }
    })
  }
  
  public selectDate = (date: Date, identifier: string): void => {
    let selectedDate = date;

    if (date) {
      if ((identifier === "dateOfPeriodForCharge") ||
         (identifier === "firstDateForCharge" && this.state.newCharge?.periodForCharge === 3)) {  // todo fix hardcoded value
        selectedDate = Time.firstDateSelectedMonth(date);
      }
    }

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        [identifier]: selectedDate,
        hasModifiedData: true
      }
    }, () => {
      if (identifier === "dateOfPeriodForCharge") {
        let typeName;

        if (!!this.state.newCharge?.typeIdForCharge) {
          const type = this.getChargeTypeBySelect(this.state.newCharge?.typeIdForCharge);
          typeName = Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system);
        }

        if (!this.state.newCharge?.descriptionForChargeIsManuallyChanged) {
          this.setDescriptionEqualToType(typeName, Formatter.monthFullFormatDate(date));
        }
      }
    });
  }

  public changeVatForCharge = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2));
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber = vatNumber / (amountForCharge - vatNumber) * 100;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        vatForCharge: vat,
        vatPercentageForCharge: isNaN(vatPercentageNumber) ? 0 : this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
        hasModifiedData: true
      }
    });
  }

  public changeVatPercentageForCharge = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2));
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vatPercentage)).replace(",", ".")).toFixed(2));
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        vatForCharge: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        vatPercentageForCharge: vatPercentage,
        hasModifiedData: true
      }
    });
  }

  public changeCurrencyIdForCharge = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        currencyIdForCharge: currency,
        hasModifiedData: true
      }
    });
  }

  public changeTypeIdForCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);
      const typeName = Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system);

      this.setState({
        newCharge: {
          ...this.state.newCharge,
          typeIdForCharge: type?.id,
          typeIdForChargeManuallyChanged: true
        }
      }, () => this.setDescriptionEqualToType(typeName, this.formatter.monthFullFormatDate(this.state.newCharge?.dateOfPeriodForCharge)));
    }
  }

  public getStatementPeriodForCharge = () => {
    const payload: any = {
      statementPeriod: Time.formatOrNull(this.state.newCharge?.firstDateForCharge)
    };

    if (this.state.newCharge?.selectedEntityForCharge instanceof Property) {
      payload.propertyId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Unit) {
      payload.unitId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Contract) {
      payload.contractId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Company) {
      payload.ownerId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Event) {
      payload.eventId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    return this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_PERIOD,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        if (data?.statementPeriod) {
          this.selectDate(new Date(data?.statementPeriod), "firstDateForCharge");
        }
      }
    })
  }

  public selectEntityForCharge = (entity: PropertyInterface | UnitInterface | ContractInterface): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedEntityForCharge: entity,
        selectedEntityForChargeManuallyChanged: true,
        hasModifiedData: true
      }
    }, this.getStatementPeriodForCharge);
  }


  
	public changeAmountForCharge = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);
    if (this.state.newCharge?.vatPercentageForCharge || this.state.newCharge?.vatPercentageForCharge === 0) {
      let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;
      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.vatPercentageForCharge)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;
      const vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;
      return this.setState({
        newCharge: {
          ...this.state.newCharge,
          vatForCharge: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
          amountForCharge: amount,
          hasModifiedData: true
        }
      });
    }

    if (this.state.newCharge?.vatForCharge) {
      let vat: string = this.state.newCharge?.vatForCharge;
      vat = this.formatter.formatSigns(vat);

      let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      const vatPercentageNumber = vatNumber / (amountForCharge - vatNumber) * 100;

      return this.setState({
        newCharge: {
          ...this.state.newCharge,
          vatPercentageForCharge: isNaN(vatPercentageNumber) ? 0 : this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
          amountForCharge: amount,
          hasModifiedData: true
        }
      });
    }

    return this.setState({
      newCharge: {
        ...this.state.newCharge,
        vatForCharge: "",
        vatPercentageForCharge: "",
        amountForCharge: amount,
        hasModifiedData: true
      }
    });
  }

  public changeInvoiceNumberForCharge = (event): void => {
    const invoiceNumber: string = event.target.value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        invoiceNumberForCharge: invoiceNumber,
        hasModifiedData: true,
      }
    });
  }


  public setDescriptionEqualToType(typeName: string, date: string) {
    if (!this.state.newCharge?.descriptionForChargeIsManuallyChanged) {
      if (!!typeName) {
        this.setState({
          newCharge: {
            ...this.state.newCharge,
            descriptionForCharge: typeName + ", " + date
          }
        });
      } else {
        this.setState({
          newCharge: {
            ...this.state.newCharge,
            descriptionForCharge: date
          }
        });
      }
    }
  }

  public fetchChargeDetails = (currentPayment: PaymentInterface): void => {
    if (!!currentPayment) {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DETAILS_FROM_LAST_SIMILAR_PAYMENT,
        payload: {
          paymentId: currentPayment?.id
        },
        onSuccess: details => {
          let entity: any;
          let counterparty: any;
          let chargeTypeId: number = details?.typeId;
          if (details?.contactId) {
            counterparty = this.props.app.persons.find(person => person.id === details.contactId);
          }

          if (details?.companyId) {
            counterparty = this.props.app.companies.find(company => company.id === details.companyId);
          }
          if (counterparty) {
            this.setState({
              newCharge: {
                ...this.state.newCharge,
                selectedCounterpartyForCharge: counterparty,
              }
            });
          }

          if (details?.ownerId) {
            entity = this.props.app.companies.find(company => company.id === details.ownerId);
          }

          if (details?.contractId) {
            entity = this.props.app.contracts.find(contract => contract.id === details.contractId);
          }

          if (details?.unitId) {
            entity = this.props.units.byId[details.unitId];
          }

          if (details?.propertyId) {
            entity = this.props.properties.byId[details.propertyId];
          }

          if (entity && !this.state.newCharge?.selectedEntityForChargeManuallyChanged) {
            this.setState({
              newCharge: {
                ...this.state.newCharge,
                selectedEntityForCharge: entity,
              }
            });
          }

          if (chargeTypeId && !this.state.newCharge?.typeIdForChargeManuallyChanged) {
            const type = this.getChargeTypeBySelect(chargeTypeId);
            const typeName = this.formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system);
            this.setState({
              newCharge: {
                ...this.state.newCharge,
                typeIdForCharge: chargeTypeId
              }
            });
            this.setDescriptionEqualToType(typeName, this.formatter.monthFullFormatDate(this.state.newCharge?.firstDateForCharge));
          }
        },
        onError: err => {
          console.log(err)
        }
      })
    }
  }

  public getChargeTypeBySelect = (id) => {
    const chargeType = Store.getConfigurator().getState().globalTypes?.ChargeType;
    if (!!id) {
      for (const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  }

  public changeTenantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantChoice: choice,
      tenant: choice === "newtenant" ? null : this.props.payment?.counterparty ? this.props.payment?.counterparty : null,
      firstName: "",
      isDisabled: choice === "newtenant" ? true : this.props.payment?.counterparty ? false : true,
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: choice === "newtenant" ? null : this.props.payment?.counterparty ? this.props.payment?.counterparty : null,
      }
    });
  }

  public chooseTenantType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: ""
    });
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      tenant: entity,
      isDisabled: false,
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: entity
      }
    })
  }

  public clearTenant = (): void => {
    this.setState({
      tenant: null,
      isDisabled: true
    });
  }

  public handleInputChange = (event, state): void => {
    this.setState({
      [state]: event.target.value
    })
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName:  type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public getPayloadTenant = (): any => {
    const pageTemplate = "person";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public createTenant = () => {
    this.setState({
      counterpartyError: null //need for clear error for occupant fields
    }, () => {
      if(this.state.tenantType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                isDisabled: false,
                tenant: person,
                counterpartySuccessfullyCreated: true,
                newCharge: {
                  ...this.state.newCharge,
                  selectedCounterpartyForCharge: person
                }
              });
            },
            onError: () => {
              this.setState({
                isSaving: false,
                isDisabled: true
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company"
              }
            },
            onSuccess: (company) => {
              this.setState({
                companyTenant: company,
                counterpartySuccessfullyCreated: true,
                showNextButton: true,
                errorFields: [],
                isSaving: false,
                isDisabled: false,
                newCharge: {
                  ...this.state.newCharge,
                  selectedCounterpartyForCharge: company
                }
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                isSaving: false,
                isDisabled: true
              })
            }
          });
        });
      }
    })
  }

  public render() {
    const steps = this.getSteps();
    let stepContentArr = []
    if (this.state.coachType === "Receivable") {
      stepContentArr = [
        <NewChargeStep3
          {...this.props}
          coachType={this.state.coachType}
          selectedOwner={this.state.selectedOwner}
          selectedAgency={this.state.selectedAgency}
          ref={this.chargeDetails}
          dispatch={this.props.dispatch}
          charge={this.state.newCharge}
          setState={(data) => this.handleChargeStateChange(data)}
          state={this.state.newCharge}
          selectCounterpartyForCharge={this.selectCounterpartyForCharge}
          clearCounterpartyForCharge={this.clearCounterpartyForCharge}
          changeTypeIdForCharge={this.changeTypeIdForCharge}
          selectEntityForCharge={this.selectEntityForCharge}
          clearEntityForCharge={this.clearEntityForCharge}
          changeDescriptionForCharge={this.changeDescriptionForCharge}
          selectDate={this.selectDate}
          changeInvoiceNumberForCharge={this.changeInvoiceNumberForCharge}
          changeAmountForCharge={this.changeAmountForCharge}
          handleChangeIsInvoice={this.handleChangeIsInvoice}
          changeVatPercentageForCharge={this.changeVatPercentageForCharge}
          changeVatForCharge={this.changeVatForCharge}
          chargeType={this.state.chargeType}
          payment={this.state.payment}
          handleShowMore={this.handleShowMore}
        />,
        <CounterpartyStep
          selectCounterpartyForCharge={this.selectCounterpartyForCharge}
          selectedCounterpartyForCharge={this.state?.newCharge?.selectedCounterpartyForCharge}
          clearCounterpartyForCharge={this.clearCounterpartyForCharge}
          tenantChoice={this.state.tenantChoice}
          changeTenantChoice={this.changeTenantChoice}
          tenant={this.state.tenant}
          companyTenant={this.state.companyTenant}
          tenantType={this.state.tenantType}
          tenantFirstName={this.state.tenantFirstName}
          tenantLastName={this.state.tenantLastName}
          chooseTenantType={this.chooseTenantType}
          selectTenant={this.selectTenant}
          clearTenant={this.clearTenant}
          handleInputChange={this.handleInputChange}
          createTenant={this.createTenant}
          coachType={this.state.coachType}
          chargeType={this.state.chargeType}
          counterpartyError={this.state.counterpartyError}
          counterpartySuccessfullyCreated={this.state.counterpartySuccessfullyCreated}
        />,
        <NewChargeStep4
          {...this.props}
          state={this.state}
          disableButtons={bool => this.setState({showLoader: bool})}
          onCreate={attachments => {this.setState({attachments: attachments})}}
        />,
        <NewChargeStep5
          {...this.props}
          state={this.state}
          getChargeTypeBySelect={this.getChargeTypeBySelect}
        />,
        this.step6Details()
      ];
    }
    if (this.state.coachType === "Payable") {
      stepContentArr = [
        <NewChargeStep3
          {...this.props}
          coachType={this.state.coachType}
          selectedOwner={this.state.selectedOwner}
          selectedAgency={this.state.selectedAgency}
          ref={this.chargeDetails}
          dispatch={this.props.dispatch}
          charge={this.state.newCharge}
          setState={(data) => this.handleChargeStateChange(data)}
          state={this.state.newCharge}
          selectCounterpartyForCharge={this.selectCounterpartyForCharge}
          clearCounterpartyForCharge={this.clearCounterpartyForCharge}
          changeTypeIdForCharge={this.changeTypeIdForCharge}
          selectEntityForCharge={this.selectEntityForCharge}
          clearEntityForCharge={this.clearEntityForCharge}
          changeDescriptionForCharge={this.changeDescriptionForCharge}
          selectDate={this.selectDate}
          changeInvoiceNumberForCharge={this.changeInvoiceNumberForCharge}
          changeAmountForCharge={this.changeAmountForCharge}
          handleChangeIsInvoice={this.handleChangeIsInvoice}
          changeVatPercentageForCharge={this.changeVatPercentageForCharge}
          changeVatForCharge={this.changeVatForCharge}
          chargeType={this.state.chargeType}
          payment={this.state.payment}
          handleShowMore={this.handleShowMore}
        />,
        <CounterpartyStep
          selectCounterpartyForCharge={this.selectCounterpartyForCharge}
          selectedCounterpartyForCharge={this.state?.newCharge?.selectedCounterpartyForCharge}
          clearCounterpartyForCharge={this.clearCounterpartyForCharge}
          tenantChoice={this.state.tenantChoice}
          changeTenantChoice={this.changeTenantChoice}
          tenant={this.state.tenant}
          companyTenant={this.state.companyTenant}
          tenantType={this.state.tenantType}
          tenantFirstName={this.state.tenantFirstName}
          tenantLastName={this.state.tenantLastName}
          chooseTenantType={this.chooseTenantType}
          selectTenant={this.selectTenant}
          clearTenant={this.clearTenant}
          handleInputChange={this.handleInputChange}
          createTenant={this.createTenant}
          coachType={this.state.coachType}
          chargeType={this.state.chargeType}
          counterpartyError={this.state.counterpartyError}
          counterpartySuccessfullyCreated={this.state.counterpartySuccessfullyCreated}
        />,
        <NewChargeStep4
          {...this.props}
          state={this.state}
          disableButtons={bool => this.setState({showLoader: bool})}
          onCreate={attachments => {this.setState({attachments: attachments})}}
        />,
        <NewChargeStep5
          {...this.props}
          state={this.state}
          getChargeTypeBySelect={this.getChargeTypeBySelect}
        />,
        this.step6Details()
      ];
    }
    if (this.state.coachType === "registerIncomingInvoice") {
      stepContentArr = [
        <NewChargeStep3
          {...this.props}
          coachType={this.state.coachType}
          selectedOwner={this.state.selectedOwner}
          selectedAgency={this.state.selectedAgency}
          ref={this.chargeDetails}
          dispatch={this.props.dispatch}
          charge={this.state.newCharge}
          setState={(data) => this.handleChargeStateChange(data)}
          state={this.state.newCharge}
          selectCounterpartyForCharge={this.selectCounterpartyForCharge}
          clearCounterpartyForCharge={this.clearCounterpartyForCharge}
          changeTypeIdForCharge={this.changeTypeIdForCharge}
          selectEntityForCharge={this.selectEntityForCharge}
          clearEntityForCharge={this.clearEntityForCharge}
          changeDescriptionForCharge={this.changeDescriptionForCharge}
          selectDate={this.selectDate}
          changeInvoiceNumberForCharge={this.changeInvoiceNumberForCharge}
          changeAmountForCharge={this.changeAmountForCharge}
          handleChangeIsInvoice={this.handleChangeIsInvoice}
          changeVatPercentageForCharge={this.changeVatPercentageForCharge}
          changeVatForCharge={this.changeVatForCharge}
          chargeType={this.state.chargeType}
          payment={this.state.payment}
        />,
        <CounterpartyStep
          selectCounterpartyForCharge={this.selectCounterpartyForCharge}
          selectedCounterpartyForCharge={this.state?.newCharge?.selectedCounterpartyForCharge}
          clearCounterpartyForCharge={this.clearCounterpartyForCharge}
          tenantChoice={this.state.tenantChoice}
          changeTenantChoice={this.changeTenantChoice}
          tenant={this.state.tenant}
          companyTenant={this.state.companyTenant}
          tenantType={this.state.tenantType}
          tenantFirstName={this.state.tenantFirstName}
          tenantLastName={this.state.tenantLastName}
          chooseTenantType={this.chooseTenantType}
          selectTenant={this.selectTenant}
          clearTenant={this.clearTenant}
          handleInputChange={this.handleInputChange}
          createTenant={this.createTenant}
          coachType={this.state.coachType}
          chargeType={this.state.chargeType}
          counterpartyError={this.state.counterpartyError}
          counterpartySuccessfullyCreated={this.state.counterpartySuccessfullyCreated}
        />,
        <NewChargeStep5
          {...this.props}
          state={this.state}
          getChargeTypeBySelect={this.getChargeTypeBySelect}
        />,
        this.step6Details()
      ];
    }
  
    return (
      <>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          stepContentArr={stepContentArr}
          openCoach={this.state.openCoach}
          onCloseCoach={this.onCloseCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({activeStep, isDisabled: false})
          }}
          showBackButton={this.state.showBackButton}
          disabled={this.state.showLoader}
          disabledBack={this.state.showLoader}
          disabledNext={this.state.showLoader || this.state.isDisabled}
        />

        <PageTransition isSaving={this.state.showLoader} />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    component: state.chargeCreateDialog
  };
};

export default connect(mapStateToProps)(
  CoachNewChargeBasedOnPayment
);
